<template>
  <div id="term-portability-element">
    <div class="flex justify-between m-2">
      <div class="w-full">
        <SmartTitle heading="2" weight="medium" class="p-1"
          >Portabilidade</SmartTitle
        >
        <SmartRow
          class="flex sub-form justify-between flex-nowrap flex-row pl-3"
        >
          <div class="w-full">
            <v-radio-group
              class="m-0"
              v-model="value.hasPortability"
              :mandatory="false"
              :id="'hasPortability_' + index + typePortability"
              row
            >
              <v-radio label="Sim" :value="true" />
              <v-radio label="Não" :value="false" />
            </v-radio-group>
          </div>
        </SmartRow>
      </div>
      <div class="w-full" v-show="value.hasPortability">
        <SmartTitle heading="2" weight="medium" class="p-1"
          >Tipo de Portabilidade</SmartTitle
        >
        <SmartRow
          class="flex sub-form justify-between flex-nowrap flex-row pl-3"
        >
          <div class="w-full">
            <v-radio-group class="m-0" v-model="value.hasPortabilityOi" row>
              <v-radio label="Outras Operadoras" :value="false" />
              <v-radio label="Cliente Oi" :value="true" />
            </v-radio-group>
          </div>
        </SmartRow>
      </div>
    </div>
    <div class="flex justify-between m-2" v-show="value.hasPortability">
      <div class="w-full">
        <SmartInput
          label="Nº a ser portado"
          :id="'portabilityPhone_' + index + typePortability"
          :mask="'(##) #####-####'"
          placeholder="Informa o Nº a ser portado"
          v-model="value.portabilityPhone"
          :name="'portabilityPhone_' + index + typePortability"
          v-validate="portabilityValidate('required|celPhone')"
          :error="errors.first('portabilityPhone_' + index + typePortability)"
          :disabled="value.hasPortabilityOi == null"
        />
      </div>
      <div class="w-full">
        <SmartInput
          label="Nº de Protocolo da Portabilidade"
          placeholder="Informa o Nº de Protocolo da Portabilidade"
          :id="'portabilityProtocol_' + index + typePortability"
          :name="'portabilityProtocol_' + index + typePortability"
          v-model="value.portabilityProtocol"
          v-validate="portabilityValidate('required')"
          :error="
            errors.first('portabilityProtocol_' + index + typePortability)
          "
          :mask="'#'.repeat(50)"
          :disabled="value.hasPortabilityOi == null"
        />
      </div>
    </div>
    <div
      class="flex justify-between m-2"
      v-show="value.hasPortability && !value.hasPortabilityOi"
    >
      <div class="w-full">
        <SmartInput
          label="Data agendada"
          type="date-picker"
          :id="'schedulingDate_' + index + typePortability"
          :name="'schedulingDate_' + index + typePortability"
          placeholder="dd/mm/aaaa"
          v-model="value.schedulingDate"
          v-validate="
            !value.hasPortabilityOi
              ? portabilityValidate('required|afterToday')
              : ''
          "
          :error="errors.first('schedulingDate_' + index + typePortability)"
          :disabled="value.hasPortabilityOi == null"
        />
      </div>
      <div class="w-full">
        <SmartInput
          label="Hora agendada"
          placeholder="00:00"
          :id="'portabilityHour_' + index + typePortability"
          :name="'portabilityHour_' + index + typePortability"
          v-model="value.portabilityHour"
          v-validate="
            !value.hasPortabilityOi ? portabilityValidate('required|hour') : ''
          "
          :mask="'##:##'"
          :error="errors.first('portabilityHour_' + index + typePortability)"
          :disabled="value.hasPortabilityOi == null"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    index: {
      type: Number,
      default: 999,
    },
    typePortability: {
      type: String,
      deafult: "",
    },
    value: {}, // eslint-disable-line
  },
  computed: {
    ...mapGetters({
      term: "term/term",
    }),
  },
  methods: {
    portabilityValidate(value) {
      let rule = value;
      if (
        this.term.tipoVenda === "posVenda" &&
        this.term.posVenda.isTrocaAparelho
      ) {
        rule = "nullable|celPhone";
      }
      return this.value.hasPortability ? rule : "";
    },
    portabilityNumberValidate(value) {
      let portabilityNumber = "";
      if (this.term.smp.portability.hasPortability) {
        portabilityNumber = `|isNotEquals:${this.term.smp.portability.portabilityPhone}`;
      }

      return this.portabilityValidate(value) + portabilityNumber;
    },
    async isValid() {
      await this.$validator.validateAll();
      return Object.keys(this.fields).every((field) =>
        this.focusOnError(field)
      );
    },
    focusOnError(field) {
      const isValid = this.fields[field].valid;
      if (!isValid) {
        document.getElementsByName(field)[0].focus();
      }
      return isValid;
    },
  },
};
</script>

<style lang="scss" scoped>
.form {
  .smart-input__wrapper {
    margin-bottom: $spacing-margin-xsmall;
  }
  .smart-select__wrapper {
    margin-bottom: $spacing-margin-xsmall;
  }
}

.red-message {
  color: red !important;
}

.message-adjust {
  margin-left: -10%;
  margin-top: 1%;
}

@media (max-width: 600px) {
  #term-portability-element {
    display: flex !important;
    flex-direction: column !important;
    width: 100% !important;

    .flex-nowrap {
      flex-wrap: wrap !important;
    }

    .w-full {
      margin-top: 20px;
      display: flex !important;
    }

    .flex-row {
      flex-direction: column !important;
    }

    .justify-between {
      display: flex;
      flex-wrap: wrap !important;
      flex-direction: column !important;
      justify-content: flex-start !important;
    }
  }
}
</style>
